import React from "react";
import { FaSitemap, FaRegCheckSquare } from "react-icons/fa";

// Kart/liste için 1.1 göstergeleri: üst iş anahtarı ve alt iş / kontrol listesi sayaçları.

export function ParentKey({ parent, className = "" }) {
  if (!parent?.key) return null;
  return (
    <span className={`text-xs text-gray-400 ${className}`} title={parent.title} data-testid="task-parent-key">
      ↳ {parent.key}
    </span>
  );
}

function Count({ count, icon: Icon, title, testId }) {
  if (!count || !(count.total > 0)) return null;
  const complete = count.done >= count.total;
  return (
    <span
      className={`inline-flex items-center gap-1 ${complete ? "text-sixth" : ""}`}
      title={title}
      data-testid={testId}
    >
      <Icon className="w-3 h-3" aria-hidden="true" />
      {count.done}/{count.total}
    </span>
  );
}

export function TaskCounts({ task }) {
  return (
    <>
      <Count count={task.subtaskCount} icon={FaSitemap} title="Alt işler" testId="task-subtask-count" />
      <Count count={task.checklistCount} icon={FaRegCheckSquare} title="Kontrol listesi" testId="task-checklist-count" />
    </>
  );
}

export default TaskCounts;
